document.addEventListener("DOMContentLoaded", function() {
  window.addEventListener("scroll", function() {
    action_filter_sticky();
  });

  window.addEventListener("load", function() {
    action_filter_sticky();
  });

  function action_filter_sticky() {
    var header = document.querySelector('.header, store-header');
    var sticky_filter_btn = document.querySelector("products-toolbar.products-toolbar");

    const limit_top = header.clientHeight + 12;
    // console.log("limit_top", limit_top);
    // console.log("top", document.querySelector(".mobile-toolbar-pos").getBoundingClientRect().top);

    const current_pos_top = document.querySelector(".mobile-toolbar-pos").getBoundingClientRect().top;

    if(current_pos_top < limit_top) {
      sticky_filter_btn.classList.add("is-sticky");
    } else {
      sticky_filter_btn.classList.remove("is-sticky");
    }
  }
});
